import { defineStore } from 'pinia'
import axios from '../config/api.js'

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    stats: {
      totalEmails: 0,
      totalCommandes: 0,
      totalAnomalies: 0,
      processingRate: 0
    },
    chartData: {
      emailsOverTime: {
        labels: [],
        data: []
      },
      statusDistribution: [0, 0, 0, 0],
      anomaliesOverTime: {
        labels: [],
        data: []
      }
    },
    recentActivities: [],
    loading: false
  }),
  
  actions: {
    async loadDashboardData() {
      this.loading = true
      
      try {
        // Charger les statistiques principales
        const statsResponse = await axios.get('/api/dashboard/stats')
        this.stats = statsResponse.data
        
        // Charger les données des graphiques
        const chartsResponse = await axios.get('/api/dashboard/charts')
        this.chartData = chartsResponse.data
        
        // Charger les activités récentes
        const activitiesResponse = await axios.get('/api/dashboard/activities')
        this.recentActivities = activitiesResponse.data
        
      } catch (error) {
        console.error('Erreur lors du chargement des données du dashboard:', error)
        
        // Données de démonstration en cas d'erreur
        this.loadMockData()
      } finally {
        this.loading = false
      }
    },
    
    loadMockData() {
      // Données de démonstration
      this.stats = {
        totalEmails: 1247,
        totalCommandes: 89,
        totalAnomalies: 12,
        processingRate: 94
      }
      
      // Générer des données pour les 7 derniers jours
      const last7Days = []
      const emailsData = []
      const anomaliesData = []
      
      for (let i = 6; i >= 0; i--) {
        const date = new Date()
        date.setDate(date.getDate() - i)
        last7Days.push(date.toLocaleDateString('fr-FR', { 
          month: 'short', 
          day: 'numeric' 
        }))
        
        emailsData.push(Math.floor(Math.random() * 50) + 100)
        anomaliesData.push(Math.floor(Math.random() * 5) + 1)
      }
      
      this.chartData = {
        emailsOverTime: {
          labels: last7Days,
          data: emailsData
        },
        statusDistribution: [156, 45, 12, 89], // Traités, En attente, Erreur, Validés
        anomaliesOverTime: {
          labels: last7Days,
          data: anomaliesData
        }
      }
      
      this.recentActivities = [
        {
          id: 1,
          title: 'Nouvelle commande extraite de client@example.com',
          timestamp: Date.now() - 300000, // 5 min ago
          type: 'order',
          icon: 'fas fa-shopping-cart'
        },
        {
          id: 2,
          title: 'Email traité automatiquement',
          timestamp: Date.now() - 600000, // 10 min ago
          type: 'email',
          icon: 'fas fa-envelope'
        },
        {
          id: 3,
          title: 'Anomalie détectée: Prix incohérent',
          timestamp: Date.now() - 900000, // 15 min ago
          type: 'anomaly',
          icon: 'fas fa-exclamation-triangle'
        },
        {
          id: 4,
          title: 'Commande validée par l\'utilisateur',
          timestamp: Date.now() - 1200000, // 20 min ago
          type: 'order',
          icon: 'fas fa-check-circle'
        },
        {
          id: 5,
          title: 'Nouveau compte email configuré',
          timestamp: Date.now() - 1800000, // 30 min ago
          type: 'email',
          icon: 'fas fa-envelope-open'
        }
      ]
    },
    
    async refreshStats() {
      try {
        const response = await axios.get('/api/dashboard/stats')
        this.stats = response.data
      } catch (error) {
        console.error('Erreur lors du rafraîchissement des statistiques:', error)
      }
    },
    
    addActivity(activity) {
      this.recentActivities.unshift({
        ...activity,
        id: Date.now(),
        timestamp: Date.now()
      })
      
      // Garder seulement les 10 dernières activités
      if (this.recentActivities.length > 10) {
        this.recentActivities = this.recentActivities.slice(0, 10)
      }
    }
  }
})